import { render, staticRenderFns } from "./land-page-container.vue?vue&type=template&id=8a5e8924&scoped=true&lang=pug"
import script from "./land-page-container.js?vue&type=script&lang=js&external"
export * from "./land-page-container.js?vue&type=script&lang=js&external"
import style0 from "./land-page-container.vue?vue&type=style&index=0&id=8a5e8924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5e8924",
  null
  
)

export default component.exports